import { getInitialStateFromConfig } from "helpers/form";
import { requiredField } from "helpers/validators";
import { singleList as classificationTypesSingleList } from "sources/books/classificationTypes";

export const config = {
    documentDate: {
        label: "Дата документа",
        inputProps: { name: "documentDate", type: "date" },
        inPortal: true,
    },
    classificationType: {
        label: "Тип номенклатуры",
        inputProps: { name: "classificationType" },
        url: classificationTypesSingleList,
        propName: "name",
        menuPortalTarget: document.body,
        required: true,
        validators: [requiredField],
    },
};

export const initialState = getInitialStateFromConfig(config);
